import { IApplicationData } from 'src/interfaces/ApplicationData';
import { IApplicationPreferences } from 'src/interfaces/ApplicationPreferences';
import { get } from 'src/utils/apiUtils';
import Validator from 'src/validators/Validator';
import { schema as subtitleStylesSchema } from 'src/validators/schemas/subtitleStyles';
import {
  DEFAULT_SUBTITLE_ENABLED,
  DEFAULT_SUBTITLE_LANGUAGE,
  DEFAULT_SUBTITLE_STYLE,
} from '../UserPreferencesService/constants';
import { APPLICATION_PREFERENCES_URL } from './constants';

class ApplicationPreferencesService {
  private applicationData: IApplicationData;
  private applicationSubtitleStyle: IApplicationPreferences;
  private readonly _subtitleValidator: Validator;

  constructor() {
    this._subtitleValidator = new Validator(subtitleStylesSchema);
  }

  init(applicationData: IApplicationData) {
    this.applicationData = applicationData;
  }

  generateRequestUrl() {
    const { applicationKey } = this.applicationData;

    return `${APPLICATION_PREFERENCES_URL}/app-preferences/${applicationKey || 'default'}`;
  }

  async fetchPreferences() {
    try {
      const result = await get(this.generateRequestUrl());
      this.parsePreferences(result);
    } catch (error) {
      this.parsePreferences({});
    }
  }

  parsePreferences(preferences: Partial<IApplicationPreferences>) {
    this.applicationSubtitleStyle = {
      subtitle: {
        language: preferences.subtitle?.language ?? DEFAULT_SUBTITLE_LANGUAGE,
        enabled: preferences.subtitle?.enabled ?? DEFAULT_SUBTITLE_ENABLED,
        style: this._subtitleValidator.sanitize({
          data: preferences.subtitle?.style,
          defaultValues: DEFAULT_SUBTITLE_STYLE,
        }),
      },
    };
  }

  get applicationSubtitleStyleDefaults() {
    return this.applicationSubtitleStyle?.subtitle?.style || DEFAULT_SUBTITLE_STYLE;
  }
}

export default new ApplicationPreferencesService();
